// extracted by mini-css-extract-plugin
export default {"snowfall":"NewYear_snowfall__H0NZs","vid-container":"NewYear_vid-container__LcsMs","img-container":"NewYear_img-container__vnDcS"};